import { ArrowRight, Compass, Plus } from "lucide-react";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

export function ProjectStartChoices({ demo, onCreateProject, busy = false }: {
	demo: ReactNode;
	onCreateProject: () => void;
	busy?: boolean;
}) {
	const { t } = useTranslation();
	return (
		<section aria-label={t("dashboard.title")} className="mx-auto grid max-w-4xl grid-cols-1 gap-6 pb-16 md:grid-cols-2">
			<article className="flex flex-col rounded-2xl border border-violet-400/40 bg-violet-500/5 p-6 md:p-8">
				<div className="mb-6 flex items-center justify-between gap-3 text-violet-300">
					<Compass size={30} aria-hidden="true" />
					<span className="rounded-full bg-violet-500/15 px-3 py-1 text-xs font-semibold">{t("dashboard.discover.recommended")}</span>
				</div>
				<h2 className="text-2xl font-bold text-zinc-100">{t("dashboard.discover.title")}</h2>
				<p className="mt-3 mb-6 text-sm leading-6 text-zinc-400">{t("dashboard.discover.description")}</p>
				<div className="mt-auto">{demo}</div>
			</article>
			<article className="flex flex-col rounded-2xl border border-white/10 bg-[#111113] p-6 md:p-8">
				<Plus size={30} className="mb-6 text-zinc-400" aria-hidden="true" />
				<h2 className="text-2xl font-bold text-zinc-100">{t("dashboard.direct.title")}</h2>
				<p className="mt-3 mb-6 text-sm leading-6 text-zinc-400">{t("dashboard.direct.description")}</p>
				<button type="button" onClick={onCreateProject} disabled={busy} className="btn-pill btn-pill-secondary mt-auto inline-flex items-center justify-center gap-2 disabled:opacity-50">
					{t("dashboard.direct.cta")}<ArrowRight size={16} aria-hidden="true" />
				</button>
			</article>
		</section>
	);
}
